(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super()

      this.locked = false
      this.lock = () => {
        this.locked = true
      }
      this.unlock = () => {
        this.locked = false
      }
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header')
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size'
      this.headerBounds = {}

      if (this.headerIsAlwaysSticky) {
        document.body.classList.add('has-sticky-header')
        // this.header.classList.add('shopify-section-header-sticky')
      }

      this.currentScrollTop = 0
      this.preventReveal = false
      this.predictiveSearch = this.querySelector('predictive-search')

      this.onScrollHandler = this.onScroll.bind(this)
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

      // if (!this.headerIsAlwaysSticky) {
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.addEventListener('scroll', this.onScrollHandler, false)

      this.createObserver()
      // }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.removeEventListener('scroll', this.onScrollHandler)
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect
        observer.disconnect()
      })

      observer.observe(this.header)
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      window.scrollDirection = scrollTop > this.currentScrollTop ? 'down' : 'up'

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return

      if (!this.locked) {
        if (this.headerIsAlwaysSticky) {
          this.header.classList.toggle('shopify-section-header-fixed', scrollTop > this.headerBounds.top)
          return
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header')
          if (this.preventHide) return
          requestAnimationFrame(this.hide.bind(this))
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header')
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this))
          } else {
            window.clearTimeout(this.isScrolling)

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false
            }, 66)

            requestAnimationFrame(this.hide.bind(this))
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header')
          requestAnimationFrame(this.reset.bind(this))
        }
      } else {
        window.clearTimeout(this.isScrolling)

        this.isScrolling = setTimeout(this.unlock, 66)
      }

      this.currentScrollTop = scrollTop
    }

    hide() {
      if (this.headerIsAlwaysSticky) return
      document.body.classList.remove('has-sticky-header')
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
      this.closeMenuDisclosure()
      this.closeSearchModal()
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return
      document.body.classList.add('has-sticky-header')
      this.header.classList.add('shopify-section-header-sticky', 'animate')
      this.header.classList.remove('shopify-section-header-hidden')
    }

    reset() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate')
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu')
      this.disclosures.forEach(disclosure => disclosure.close())
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('search-modal')
      this.searchModal.close(false)
    }
  }

  customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();
})();
